import axios from "axios";
import {setAuthToken, setLoginStatus} from "./stores/auth/actions";
import {store} from "./stores/store";

const mobileAxiosInstance = axios.create({
  baseURL: process.env.REACT_APP_URL_CUST,
  headers: {
    Accept: "application/json",
    "Content-Type": "application/json",
  },
});

mobileAxiosInstance.interceptors.request.use((config) => {
  const {auth} = store.getState();
  config.headers.Authorization = `${auth.token}`;
  return config;
});

mobileAxiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response)
      if (error.response.status === 401) {
        store.dispatch(setAuthToken(null));
        store.dispatch(setLoginStatus(false));

        window.location = "/login";
      }
    throw error;
  }
);

export default mobileAxiosInstance;
